import React from 'react'

const Loading = () => {
  return <>
    <section className='loading-center'>
      <p className="nav-logo">W</p>
    </section>
  </>
}

export default Loading
